import request from '@/utils/request'
import debugLog from '@/utils/debugLog'

const base = '/s_slip_note_opts'

export function getSSNoteOpts(params) {
  // debugLog(params)
  return request({
    url: `${base}`,
    method: 'get',
    params: params
  })
}

export function getSSNoteOpt(id) {
  return request({
    url: `${base}/${id}`,
    method: 'get'
  })
}

export function patchSSNoteOpt(record) {
  const params = { s_slip_note_opt: { note: record.note}}
  debugLog({record: record, params: params})
  return request({
    url: `${base}/${record.id}`,
    method: 'patch',
    data: params
  })
}

export function postSSNoteOpt(record) {
  const params = { s_slip_note_opt: { note: record.note}}
  return request({
    url: `${base}/`,
    method: 'post',
    data: params
  })
}
